import { useQuery } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import plgAnticipationService from 'v2/services/plgAnticipation';

import type { PlgAnticipationResponse } from 'v2/interfaces/plgAnticipation';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';

export function useGetPlgAnticipation(options: UseQueryOptions<PlgAnticipationResponse> = {}) {
  return useQuery({
    queryKey: ['plgAnticipation'],
    queryFn: () => plgAnticipationService.getPlgAnticipation(),
    ...options,
  });
}

export function usePlgSaveAccess(options: UseMutationOptions<void, unknown, string> = {}) {
  return useMutation({
    mutationFn: async (screen: string) => plgAnticipationService.plgSaveAccess(screen),
    ...options,
  });
}
